// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f0f2f5;
}
.login-container .login-form {
  background-color: #ffffff;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 30em;
  text-align: center;
}
.login-container .login-form h2 {
  margin-bottom: 25px;
  color: #333;
}
.login-container .login-form .form-group {
  margin-bottom: 20px;
  text-align: left;
}
.login-container .login-form .form-group label {
  display: block;
  margin-bottom: 8px;
  color: #555;
  font-weight: bold;
}
.login-container .login-form .form-group input[type=email],
.login-container .login-form .form-group input[type=password] {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-sizing: border-box;
  font-size: 16px;
}
.login-container .login-form button {
  background-color: #007bff;
  color: white;
  display: block;
  width: 100%;
  margin-top: 12px;
  padding: 12px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s ease;
}
.login-container .login-form button:hover {
  background-color: #0056b3;
}`, "",{"version":3,"sources":["webpack://./frontend/sass/pages/login.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;AAAF;AAEE;EACE,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,wCAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AAAJ;AAEI;EACE,mBAAA;EACA,WAAA;AAAN;AAGI;EACE,mBAAA;EACA,gBAAA;AADN;AAGM;EACE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;AADR;AAIM;;EAEE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AAFR;AAMI;EACE,yBAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,sCAAA;AAJN;AAMM;EACE,yBAAA;AAJR","sourcesContent":["// src/styles/Login.scss\n.login-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background-color: #f0f2f5;\n\n  .login-form {\n    background-color: #ffffff;\n    padding: 40px;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    width: 100%;\n    max-width: 30em;\n    text-align: center;\n\n    h2 {\n      margin-bottom: 25px;\n      color: #333;\n    }\n\n    .form-group {\n      margin-bottom: 20px;\n      text-align: left;\n\n      label {\n        display: block;\n        margin-bottom: 8px;\n        color: #555;\n        font-weight: bold;\n      }\n\n      input[type=\"email\"],\n      input[type=\"password\"] {\n        width: 100%;\n        padding: 12px;\n        border: 1px solid #ddd;\n        border-radius: 4px;\n        box-sizing: border-box; // Ensures padding doesn't increase width\n        font-size: 16px;\n      }\n    }\n\n    button {\n      background-color: #007bff;\n      color: white;\n      display: block;\n      width: 100%;\n      margin-top: 12px;\n      padding: 12px 20px;\n      border: none;\n      border-radius: 4px;\n      cursor: pointer;\n      font-size: 16px;\n      transition: background-color 0.3s ease;\n\n      &:hover {\n        background-color: #0056b3;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
